import React from 'react'
import style from './input.module.scss'
import { Input } from "antd"

interface Props {
  text?: string
  placeholder?: string;
  hint?: string;
  val?: string;
  setval?: any;
  classnames?: string;
  setIsFocus?: any;
  IsFocus?: any;
}

const RechargeInput: React.FC<Props> = ({ text, placeholder, hint, val, setval, classnames, setIsFocus, IsFocus }) => {
  // const [IsFocus, setIsFocus] = useState(false)
  const inpuchange = (e) => {
    // console.log(e.target.value)
    setval(e.target.value)
  }
  //聚焦事件
  const inputFocus = () => {
    setIsFocus && setIsFocus('focus')
  }
  //失焦事件
  const inputBlur = () => {
    setIsFocus && setIsFocus('blur')
  }

  return (
    <div className={classnames ? style[classnames] : style.RechargeInput} style={{ borderBottom: IsFocus === 'error' ? '1px solid #CD2221' : IsFocus === 'focus' && '1px solid #3E9E86' }}>
      <Input style={{paddingLeft:0}} className={style.inp} bordered={false} placeholder={placeholder} value={val} onChange={(e) => inpuchange(e)} onFocus={() => inputFocus()} onBlur={() => inputBlur()} />
      <div className={style.hint}>
        {hint}
      </div>
    </div>
  )
}

export default RechargeInput
